import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Wyoming Tier2 Submit": {
    parameters: {
      linkUrls: ["https://wyo.tieriiportal.aristatek.com/"],
      staffInputs: {
        documentTypes: {
          submission: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Tier2 Submit",
    state: "WY",
  },
};
